/**
 * External dependencies
 */
import React from 'react';
import {
  ReactRouterBreadcrumb,
  ReactRouterBreadcrumbItem,
  ReactRouterBreadcrumbLink,
  ReactRouterBreadcrumbList,
  ReactRouterBreadcrumbPage,
  ReactRouterBreadcrumbSeparator,
} from './react-router-breadcrumb';

export function Breadcrumbs({
  navList,
}: {
  navList: {
    name: string;
    href: string;
  }[];
}) {
  const currentPage = navList[navList.length - 1];
  const items = navList.slice(0, -1);

  return (
    <ReactRouterBreadcrumb className="my-4">
      <ReactRouterBreadcrumbList>
        {items.map((item, index) => (
          <React.Fragment key={item.href}>
            <ReactRouterBreadcrumbItem key={index}>
              <ReactRouterBreadcrumbLink to={item.href}>
                {item.name}
              </ReactRouterBreadcrumbLink>
            </ReactRouterBreadcrumbItem>
            <ReactRouterBreadcrumbSeparator key={`separator-${index}`} />
          </React.Fragment>
        ))}
        <ReactRouterBreadcrumbPage>
          {currentPage?.name}
        </ReactRouterBreadcrumbPage>
      </ReactRouterBreadcrumbList>
    </ReactRouterBreadcrumb>
  );
}
